import { render, staticRenderFns } from "./EditEmailPage.vue?vue&type=template&id=4d81f266&scoped=true&"
import script from "./EditEmailPage.vue?vue&type=script&lang=js&"
export * from "./EditEmailPage.vue?vue&type=script&lang=js&"
import style0 from "./EditEmailPage.vue?vue&type=style&index=0&id=4d81f266&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d81f266",
  null
  
)

export default component.exports